import request from '@/utils/request';
import qs from 'qs'

const isGloria = window.location.href.indexOf('gloria') != -1 ? true : false;

function buildRequest(method, url, params, contentType) {   
    return request({
        url: url,
        method: method,
        params
        //data: qs.stringify(params||{})
    })
}
const api = {
    // url: 'http://112.74.79.227:3000/mock/20',
    url: 'http://interface.gloria.com.cn:28080/kanban',
    get(url, obj) {
        return buildRequest('get', this.url + url, obj)
    },
    post(url, obj) {
        return buildRequest('post', this.url + url, obj)
    }
}
const apitest = {

    url: process.env.VUE_APP_GLY_URL,
    get(url, obj) {
        return buildRequest('get', this.url + url, obj)
    },
    post(url, obj) {
        return buildRequest('post', this.url + url, obj)
    }
}
export {
    api,
    apitest
}